// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_vzW87","wrapinner":"index_wrapinner_yvBxf"};